// Animated accordion adapted from: https://css-tricks.com/how-to-animate-the-details-element-using-waapi/
if (!customElements.get("collapsible-row")) {
  customElements.define(
    "collapsible-row",
    class CollapsibleRow extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }
      connectedCallback() {
        this.el = this.querySelector("details");
        this.summary = this.el.querySelector("summary");
        this.content = this.summary.nextElementSibling;

        this.animation = null;
        this.dataset.open = this.el.open;
        this.dataset.closing = false;
        this.dataset.expanding = false;
        this.summary.addEventListener("click", this.handleClick);
      }

      disconnectedCallback() {
        if (this.summary) {
          this.summary.removeEventListener("click", this.handleClick);
        }
      }

      get isClosing() {
        return this.dataset.closing === "true";
      }
      get isExpanding() {
        return this.dataset.expanding === "true";
      }

      handleClick(e) {
        e.preventDefault();
        this.el.style.overflow = "hidden";
        if (this.isClosing || !this.el.open) {
          this.open();
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }

      shrink() {
        this.dataset.open = false;
        this.dataset.closing = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
        if (this.animation) {
          this.animation.cancel();
        }
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 300,
            easing: "cubic-bezier(0.61, 1, 0.88, 1)",
          }
        );
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => (this.dataset.closing = false);
      }

      open() {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        this.dataset.open = true;
        window.requestAnimationFrame(() => this.expand());
      }

      expand() {
        this.dataset.expanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${
          this.summary.offsetHeight + this.content.offsetHeight
        }px`;
        if (this.animation) {
          this.animation.cancel();
        }
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 500,
            easing: "cubic-bezier(0.37, 0, 0.63, 1)",
          }
        );
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => (this.dataset.expanding = false);
      }

      onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.dataset.closing = false;
        this.dataset.expanding = false;
        this.el.style.height = this.el.style.overflow = "";
      }
    }
  );
}
